import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13.707 10.293C13.4418 10.293 13.1875 10.3984 13 10.586L9.99997 13.586L3.70697 7.29297L2.29297 8.70697L8.99997 15.414C9.18746 15.6015 9.44177 15.7069 9.70697 15.707H10.293C10.5582 15.7069 10.8125 15.6015 11 15.414L14 12.414L18.293 16.707L16 19H22V13L19.707 15.293L15 10.586C14.8125 10.3984 14.5582 10.293 14.293 10.293H13.707Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "TrendingDown"
);
